// extracted by mini-css-extract-plugin
export var audioPlayer = "_rz-0";